import { render, staticRenderFns } from "./editDescriptionAndComments.vue?vue&type=template&id=a64e89bc&scoped=true&"
import script from "./editDescriptionAndComments.vue?vue&type=script&lang=js&"
export * from "./editDescriptionAndComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64e89bc",
  null
  
)

export default component.exports